import React from "react";
import { getPddAssociateInvitation } from "@/services/api/shop";
import { Modal } from "antd";

export async function showAssociateInvitationDialog() {
    const invitation = await getPddAssociateInvitation();

    if (!invitation) return;

    /** 如果没有url，说明目前不是主账号，不能进行操作 */
    const { inviterShopName, associateUrl } = invitation;

    const { destroy } = Modal.warning({
        content: `店铺${inviterShopName}邀请关联您的店铺，请点击下方同意关联按钮允许授权并关联店铺`,
        okCancel: true,
        cancelText: "取消",
        okText: "同意关联",
        onOk() {
            if (associateUrl) {
                window.open(associateUrl, "_self");
            } else {
                destroy();

                Modal.error({ content: "为保证店铺数据安全，主账号才能同意关联，请联系该店铺主账号操作" });
            }
        },
    });
}
